import React, { useState, useEffect, useMemo, useCallback, useReducer } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Table from '@components/table';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API, DASHBOARD_QUALITY_COLOURS } from '@awp/constants';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { debounce } from '@awp/helpers/Utils';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { isValueEmpty, sortAllFrostProbeTypeData } from '@awp/helpers/utilsReact';
import { Button, Row, Col, Card, Form, Alert } from 'react-bootstrap';
import { format as formatDate } from 'date-fns';
import { IconCaretDownFill, IconCaretRightFill } from '@awp/components/awpIcons';
import ObservationValidationHistoryTable from '@awp/tables/observationValidationHistoryTable';
import { currentEndDate, currentDisplayDay, currentDisplayDays } from '@stores/dashboardViewPageSlice';

const DetailSensorObservationTypeTable = ({ idx, sensorPlacementId, sensorObservationTypeList }) => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const endDate = useSelector(currentEndDate);
  const displayDays = useSelector(currentDisplayDay);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* useEffect(() => {
		const handleResize = debounce(() => {
			setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
		}, 100);

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		}
	}); */
  useEffect(() => {
    if (isValueEmpty(sensorPlacementId)) return;
    fetchData(); //children function of interest
  }, [sensorPlacementId]);

  const fetchData = useCallback(() => {
    setLoading(true);
    let strEndDate = formatDate(new Date(endDate), 'yyyy-MM-dd-HH-mm');
    let url = REST_API.SENSOR_OBSERVATION_TYPES + sensorPlacementId + '/' + displayDays.value + '/' + strEndDate;

    GetJson(url)
      .then((response) => response.json())
      .then((data) => {
        if (isValueEmpty(data) || data.length === 0) setData(data);
        console.log(data);
        let _data = data.filter(
          (item) =>
            item &&
            item.ObservationTypeId &&
            item.InvalidObservationCount > 0 &&
            Number(getInvaidCount(item.ObservationTypeId)) > 0,
        );
        setData(_data);
        setLoading(false);
      });
  }, [sensorPlacementId]);

  const cellComponentExp = ({ row }) => (
    // Use Cell to render an expander for each row.
    // We can use the getToggleRowExpandedProps prop-getter
    // to build the expander.
    <span {...row.getToggleRowExpandedProps()}>{row.isExpanded ? <IconCaretDownFill /> : <IconCaretRightFill />}</span>
  );

  const getInvaidCount = (observationTypeId) => {
    if (isValueEmpty(sensorObservationTypeList) || !sensorObservationTypeList.DashboardSensorObservationDTOList)
      return 0;

    const sotDtos = sensorObservationTypeList.DashboardSensorObservationDTOList.filter(
      (sot) => sot && sot.ObservationTypeId === observationTypeId,
    );

    if (sotDtos.length === 0) return 0;

    // Since there are duplicate items with the same ObservationTypeId, let's find the maximum invalid count value.
    let invalidCount = 0;
    sotDtos.forEach((dto) => {
      if (dto.InvalidObservationCount > invalidCount) {
        invalidCount = dto.InvalidObservationCount;
      }
    });

    return invalidCount;
  };

  const TableColumns = useMemo(
    () => [
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        Cell: cellComponentExp,
      },
      {
        Header: 'Observation Type',
        accessor: 'ObservationTypeDisplayName',
        //className:"col-1",
        sortType: sortByNumericThenAlpha,
        Cell: ({ row, value }) => {
          let v = value;
          if (row && row.original && !isValueEmpty(row.original.RelativeElevationMillimetres)) {
            let rev = row.original.RelativeElevationMillimetres / 10;
            v = v + ' (' + rev + ' cm)';
          }

          return v;
        },
      } /* ,
		{
			Header: "",
			accessor: "ObservationTypeId",
			sortType: sortByNumericThenAlpha,
			Cell: ({  value }) => {
				if(isValueEmpty(value) ) return "";
				if(Number(getInvaidCount(value))>0)
					return (<i className="fa fa-exclamation-circle fa-sm" style={{color: DASHBOARD_QUALITY_COLOURS[1]}} />);
				return "";
			}
		} */,
    ],
    [isMedium],
  );

  const renderRowSubComponent = useCallback(
    ({ row }) => {
      if (!row || !row.original || !displayDays || !endDate) return;
      let currentRow = row.original;
      let _displayDays = displayDays.value;
      let _collectionIntervalMins = 60;
      let dto = {
        To: formatDate(new Date(endDate), 'yyyy-MM-dd-HH-mm'),
        ObservationTypeId: currentRow.ObservationTypeId,
        SensorPlacementId: currentRow.SensorPlacementId,
        SensorLayerNumber: currentRow.SensorLayerNumber,
      };
      return (
        <Row>
          <Col>
            <div style={{ width: '400px', overflowX: 'scroll' }}>
              <ObservationValidationHistoryTable
                idx={`tbl_obs_valid_hist_log_${currentRow.Id}`}
                requestDTO={dto}
                displayDays={_displayDays}
                collectionIntervalMins={_collectionIntervalMins}
              />
            </div>
          </Col>
        </Row>
      );
    },
    [endDate, displayDays],
  );
  return (
    <Table
      id={idx}
      columns={TableColumns}
      data={data}
      fetchData={() => {}}
      loading={loading}
      search={[]}
      filters={[]}
      dataTriggers={[]}
      //hiddenColumns= {["RelativeElevationMillimetres"]}
      defaultSortBy={['ObservationTypeName']}
      renderRowSubComponent={renderRowSubComponent}
      //defaultDesc={true}
      expendCellStyle={{ paddingTop: '0rem', paddingBottom: '0rem' }}
      defaultPageSize={5} //must be one of [5, 10, 25, 50, 100]
    />
  );
};
DetailSensorObservationTypeTable.propTypes = {
  idx: PropTypes.string,
  //requestDTO:PropTypes.object
};
export default DetailSensorObservationTypeTable;
